import React, { useState } from 'react';
import { EventSettings } from '../types';

interface HeroProps {
  settings: EventSettings;
  onRegisterClick: () => void;
  onRetrievePass: (query: string) => void;
}

export const Hero: React.FC<HeroProps> = ({ settings, onRegisterClick, onRetrievePass }) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative min-h-[90vh] flex flex-col items-center justify-center text-center px-4 overflow-hidden pt-12">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.05)_0,transparent_70%)]"></div>
      
      <div className="max-w-4xl space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-1000">
        <div>
          <h2 className="text-gold font-stencil text-2xl md:text-3xl mb-2 tracking-[0.4em] drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]">
            {settings.tagline}
          </h2>
          <h1 className="text-6xl md:text-[8rem] font-stencil text-white leading-none tracking-tighter opacity-90">
            {settings.eventName}
          </h1>
          <p className="text-sm md:text-lg font-bold text-red-600 tracking-[0.5em] mt-4 uppercase">7DBN & 6DBN ARMY WING</p>
        </div>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed font-display font-light">
          {settings.description}
        </p>

        <div className="flex flex-col items-center gap-10 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 w-full">
            <button 
              onClick={onRegisterClick}
              className="group relative px-12 py-5 bg-red-900 text-white font-black text-xl rounded-sm overflow-hidden transition-all hover:bg-red-800 shadow-2xl shadow-red-900/40 w-full md:w-auto"
            >
              <span className="relative z-10 uppercase tracking-widest">Register College</span>
              <div className="absolute inset-0 bg-gold/10 transform translate-y-full group-hover:translate-y-0 transition-transform"></div>
            </button>

            <div className="flex items-center gap-1 border-l-2 border-gold/30 pl-6 text-left hidden md:flex">
              <div className="flex flex-col">
                <span className="text-[10px] font-black text-gold tracking-widest uppercase">Target Location</span>
                <span className="font-display font-bold text-lg">{settings.location}</span>
              </div>
              <div className="flex flex-col ml-8">
                <span className="text-[10px] font-black text-red-700 tracking-widest uppercase">Target Date</span>
                <span className="font-display font-bold text-lg">{settings.date}</span>
              </div>
            </div>
          </div>

          <div className="glass p-1 rounded-2xl flex flex-col md:flex-row items-center gap-2 max-w-md w-full border border-white/5">
            <input 
              type="text"
              placeholder="Enter Pass ID or Email"
              className="bg-transparent border-none focus:ring-0 text-xs px-6 py-3 w-full text-center md:text-left placeholder:text-gray-600 uppercase font-bold tracking-widest"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onRetrievePass(searchQuery)}
            />
            <button 
              onClick={() => onRetrievePass(searchQuery)}
              className="bg-gold text-black px-6 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-white transition-all w-full md:w-auto"
            >
              Retrieve Pass
            </button>
          </div>
          <p className="text-[9px] text-gray-600 uppercase font-bold tracking-[0.2em]">Lost your ticket? Enter your details above.</p>
        </div>
      </div>
      
      <div className="absolute bottom-8 opacity-20 animate-bounce">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>
      </div>
    </section>
  );
};